import React from 'react';
import { DarkBackground } from 'scy/Background';
import { WideContainer, NarrowContainer } from 'scy/layouts';
import { Hero, Title, H3, Paragraph, AccentBody } from 'scy/text';
import Racecar from 'images/icons/racecar.svg?react-svg';
import FireSale from 'images/icons/fire-sale.svg?react-svg';
import Shaker from 'images/icons/shaker.svg?react-svg';
import { pageContainer, borderBox, textCenter } from 'scy/utils.mod.scss';
import styles from './styles.mod.scss';
import { tablet_flex } from 'scy/display.mod.scss';
import { spaceBetween } from 'scy/flex.mod.scss';
import {
  ctaSection,
  ctaIcon,
  ctaTitle,
  ctaCaption
} from '../gifting/styles.mod.scss';
import { TextHR } from 'scy/HR';

export default function CorporateAccounts() {
  return (
    <div className={`${pageContainer} ${borderBox} ${textCenter}`}>
      <DarkBackground className={styles.background}>
        <Hero>Corporate Accounts</Hero>
      </DarkBackground>

      <WideContainer>
        <Title responsive tag="h2" className={styles.subtitle}>
          A team that drinks together, thinks together.
        </Title>
        <Paragraph className={styles.caption}>
          Our concierge can create unique weekly or monthly orders a happy hour
          experiences tailored to your office’s tastes. For offices that work
          late, we can stock your fridge with beers, wines and spirits that will
          have your team wanting to work late every week. We’ll bring the happy
          hour to you. You can take the credit.
        </Paragraph>

        <div className={`${tablet_flex} ${spaceBetween}`}>
          <section className={ctaSection}>
            <AccentBody className={ctaIcon}>
              <Racecar />
            </AccentBody>
            <H3 className={ctaTitle}>Ready when you are</H3>
            <Paragraph className={ctaCaption}>
              10% off all your orders + special discounts, giving you the best
              pricing. No strings attached.
            </Paragraph>
          </section>

          <section className={ctaSection}>
            <AccentBody className={ctaIcon}>
              <FireSale />
            </AccentBody>
            <H3 className={ctaTitle}>Discount pricing</H3>
            <Paragraph className={ctaCaption}>
              Set a budget, give us preferences & we’ll curate an order perfect
              for your team. We can deliver weekly, monthly or whenever you
              need.
            </Paragraph>
          </section>

          <section className={ctaSection}>
            <AccentBody className={ctaIcon}>
              <Shaker />
            </AccentBody>
            <H3 className={ctaTitle}>Let us surprise you</H3>
            <Paragraph className={ctaCaption}>
              With the largest selection online, surprise your team with craft
              beers, wines and cocktails.
            </Paragraph>
          </section>
        </div>

        <div className={styles.hr}>
          <TextHR>Tell Us About Your Team</TextHR>
        </div>
      </WideContainer>
      <NarrowContainer>
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLScWKtyIIi0mR7qmE0EeUq31wq0_VttSSG2_D178dNX-7zh8mw/viewform?embedded=true"
          width="95%"
          height="1752"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
        >
          Loading…
        </iframe>
      </NarrowContainer>
    </div>
  );
}
